<template>
  <div>
    <div class="container-fluid">
      <Breadcrumbs main="Рейтинг" title="Создать BPL сезон"/>
      <b-alert
          v-if="message"
          :variant="isError ? 'danger' : 'success'"
          :show="true"
          dismissible
          @dismissed="message = ''"
          class="mt-3"
      >
        {{ message }}
      </b-alert>
      <b-form @submit.prevent="createBplSeasonal">
        <div>
          <label>Укажите название сезона</label>
          <b-input v-model="name" placeholder="название"/>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <b-button variant="primary" type="submit">
            Создать
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "CreateBplSeasonal",
  components: {},
  created() {
  },
  data() {
    return {
      name: "",
      message: "",
      isError: false,
    }
  },
  methods: {
    async createBplSeasonal() {
      try {
        const res = await api.rating.createBplSeasonal({name: this.name});
        this.name = ""
        if (res.status === 201) {
          this.message = "Сезон успешно создан";
          this.isError = false;
          setTimeout(() => {
            this.message = "";
          }, 5000);
        }
      } catch (error) {
        this.message = error.response?.data?.message || error?.message || "";
        this.isError = true;
        setTimeout(() => {
          this.message = "";
        }, 5000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>